<template>
  <div class="flex-wrap flex-between" style="padding:0 10px;font-weight:bold;padding-left:0;position:relative;left:-5px;padding:2px 5px;border-radius:50px;margin-bottom:10px;">
    <div class="flex-wrap">
      <BaseIcon icon="dot" :color="primary || 'var(--primary)'" style="margin-right:5px" />{{name}}
      <div style="height:20px;border-bottom:2px solid var(--primary);position:relative;top:-9px;width:25px;margin-left:10px;" :style="`border-color:${primary || 'var(--primary)'}`"></div>
      <BaseIcon icon="dot" :color="primary || 'var(--primary)'" :size="14" />
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['name', 'color', 'primary'],
};
</script>

<style lang="scss" scoped>
</style>
